/** Join class names, skipping falsy parts: `cx(styles.button, active && styles.active)`. */
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter((part): part is string => typeof part === "string" && part !== "").join(" ");
}
